export default "__VITE_ASSET__f0fe17fd__"